import { render } from "./summaryTable.vue?vue&type=template&id=58df0385&scoped=true"
import script from "./summaryTable.vue?vue&type=script&lang=js"
export * from "./summaryTable.vue?vue&type=script&lang=js"

import "./summaryTable.vue?vue&type=style&index=0&id=58df0385&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58df0385"]])

export default __exports__